import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-inner-page" }
const _hoisted_2 = { class: "container mx-auto p-4 pb-10 md:p-8 lg:p-10" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" « Voltar ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "inner-page-titles" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Sétima Fase"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "CNH"),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SOCIAL")
], -1)
const _hoisted_5 = { class: "mb-8 flex h-auto flex-wrap gap-3 py-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "h-14 w-full rounded-full bg-yellow-500 px-3 py-2 leading-5 hover:bg-yellow-600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-800" }, [
    /*#__PURE__*/_createTextVNode(" 2ª Chamada "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 6ª e 7ª Fases ")
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "h-14 w-full rounded-full bg-yellow-400 bg-opacity-60 px-3 py-2 leading-5 hover:bg-yellow-500" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-800" }, "Selecionados")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "rounded-md bg-green-400 bg-opacity-40 p-8 text-xl leading-tight text-gray-900 xl:w-3/4 2xl:w-2/3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-2 font-bold" }, "Atenção", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Os selecionados deverão fazer a entrega dos documentos de 24 de julho a 11 de agosto.", -1)
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Na capital, a entrega deverá ser efetuada na sede do Departamento de Trânsito, das 8h às 14h50, com agendamento prévio por meio do ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" . ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " No interior, os agendamentos e entregas da documentação deverão ser realizadas, presencialmente, nos postos de atendimento do Detran-AM e nas autoescolas credenciadas em cada município, das 8h às 14h. ", -1)
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Para mais informações confira o site do ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" . ")
const _hoisted_20 = { class: "text-xl leading-none" }
const _hoisted_21 = {
  id: "segunda-chamada-6-7",
  class: "mb-4 pt-12"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", { class: "line mb-3 self-center uppercase" }, [
  /*#__PURE__*/_createTextVNode(" Relação de "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "segunda chamada"),
  /*#__PURE__*/_createTextVNode(" de candidatos da "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "6ª fase"),
  /*#__PURE__*/_createTextVNode(" e "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "7ª fase")
], -1)
const _hoisted_23 = { class: "mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 self-center font-bold uppercase" }, "Capital", -1)
const _hoisted_25 = { class: "mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 self-center font-bold uppercase" }, "Interior", -1)
const _hoisted_27 = {
  id: "relacao-geral",
  class: "mb-4 pt-12"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", { class: "mb-3 self-center uppercase" }, [
  /*#__PURE__*/_createTextVNode(" Relação geral de candidatos "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "selecionados")
], -1)
const _hoisted_29 = { class: "mb-3 flex flex-wrap justify-between bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "self-center uppercase" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Interior")
], -1)
const _hoisted_31 = {
  id: "selecionados",
  class: "mb-4 pt-12"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("li", { class: "mb-3 self-center uppercase" }, [
  /*#__PURE__*/_createTextVNode(" Relação de candidatos "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "selecionados"),
  /*#__PURE__*/_createTextVNode(" por município ")
], -1)
const _hoisted_33 = { class: "self-center uppercase" }
const _hoisted_34 = ["textContent"]
const _hoisted_35 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "mb-5 inline-block rounded-full bg-yellow-400 px-5 py-3 font-bold"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "flex w-40 items-center justify-center",
          href: "#segunda-chamada-6-7",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackClick('Button', '2ª Chamada 6ª e 7ª Fases')))
        }, _hoisted_7),
        _createElementVNode("a", {
          href: "#relacao-geral",
          class: "flex w-40 items-center justify-center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackClick('Button', 'Selecionados 7ª Fase')))
        }, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("p", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("a", {
            target: "_blank",
            class: "font-bold text-green-900 underline",
            href: "https://digital.detran.am.gov.br",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackClick('Link', 'Detran Digital')))
          }, " Detran Digital "),
          _hoisted_15
        ]),
        _hoisted_16,
        _createElementVNode("p", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("a", {
            target: "_blank",
            class: "font-bold text-green-900 underline",
            href: "https://www.detran.am.gov.br/cnh-social-detran-am-divulga-lista-da-segunda-chamada-dos-contemplados-da-6a-e-7a-fases-do-primeiro-ciclo/",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackClick('Link', 'Detran Site')))
          }, " DETRAN "),
          _hoisted_19
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("ul", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("li", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("a", {
              class: "inline-block rounded bg-yellow-400 px-5 py-2 uppercase",
              href: "/files/setima-fase/SEG_CHAM_SEXTA_SETIMA_CAPITAL_CNH.pdf",
              target: "_blank",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trackClick('Download', 'Baixar PDF 6/7ª Fase - Capital')))
            }, " Baixar pdf ")
          ]),
          _createElementVNode("li", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("a", {
              class: "inline-block rounded bg-yellow-400 px-5 py-2 uppercase",
              href: "/files/setima-fase/SEG_CHAM_SEXTA_SETIMA_INTERIOR_CNH.pdf",
              target: "_blank",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.trackClick('Download', 'Baixar PDF 6/7ª Fase - Interior')))
            }, " Baixar pdf ")
          ])
        ]),
        _createElementVNode("ul", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("li", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("a", {
              href: "/files/setima-fase/CANDIDATOS_SETIMA_FASE_RELACAO_GERAL.pdf",
              target: "_blank",
              class: "inline-block rounded bg-yellow-400 px-5 py-2 uppercase",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trackClick('Download', 'Baixar PDF Selecionados - Geral')))
            }, " Baixar pdf ")
          ])
        ]),
        _createElementVNode("ul", _hoisted_31, [
          _hoisted_32,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.municipios, (municipio) => {
            return (_openBlock(), _createElementBlock("li", {
              key: municipio,
              class: "mb-3 flex items-center justify-between gap-3 bg-blue-500 bg-opacity-30 p-3 xl:w-3/4 2xl:w-2/3"
            }, [
              _createElementVNode("p", _hoisted_33, [
                _createElementVNode("span", {
                  class: "font-bold",
                  textContent: _toDisplayString(municipio.nome)
                }, null, 8, _hoisted_34)
              ]),
              _createElementVNode("a", {
                href: municipio.link,
                target: "_blank",
                class: "inline-block whitespace-nowrap rounded bg-yellow-400 px-5 py-2 uppercase",
                onClick: ($event: any) => (_ctx.trackClick('Download', `Baixar PDF Selecionados - ${municipio.nome}`))
              }, " Baixar pdf ", 8, _hoisted_35)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}